import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import type { Car } from '@/api/cars/types';
import { client } from '@/api/common';

type Variables = {
  id: number;
};
export type RelistCarResponse = {
  data: Car;
};

export const useRelistCar = createMutation<
  RelistCarResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: `v2/internal/partners/cars/${variables.id}/relist`,
      method: 'PUT',
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
